import React, { useEffect, useId, useRef, useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';

export default function OpsProfitabilityClientSelect({ clients, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [draft, setDraft] = useState(selected);
  const root = useRef(null);
  const listId = useId();
  const names = [...new Set(clients.map(client => client.nombre_comercial))].sort((first, second) => first.localeCompare(second, 'es'));
  const matches = names.filter(name => name.toLocaleLowerCase('es-MX').includes(query.trim().toLocaleLowerCase('es-MX')));
  const apply = () => {
    onChange(query.trim() ? matches.filter(name => draft === null || draft.includes(name)) : draft);
    setOpen(false);
  };
  useEffect(() => {
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, []);
  return <div className="opr-client-select opr-search-field" ref={root} onKeyDown={event => { if (event.key === 'Escape') setOpen(false); }}>
    <span className="opr-filter-label">Cliente</span>
    <button type="button" className="opr-client-trigger" aria-label="Seleccionar clientes" aria-expanded={open} aria-controls={listId} onClick={() => { if (!open) { setDraft(selected); setQuery(''); } setOpen(!open); }}>
      <Search size={15} /><span>{selected === null ? 'Todos los clientes' : `${selected.length} clientes seleccionados`}</span><ChevronDown size={14} />
    </button>
    {open && <div className="opr-client-menu" id={listId}>
      <label className="opr-search"><Search size={14} /><input autoFocus type="search" aria-label="Buscar clientes disponibles" placeholder="Buscar cliente..." value={query} onChange={event => { setQuery(event.target.value); setDraft(null); }} onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault(); apply(); } }} /></label>
      <div className="opr-client-commands"><button type="button" onClick={() => { setDraft(null); setQuery(''); }}>Todos los clientes</button><button type="button" onClick={() => setDraft([])}>Limpiar selección</button></div>
      <div className="opr-client-options" role="group" aria-label="Clientes disponibles">
        {matches.map(name => <label key={name}><input type="checkbox" checked={draft === null || draft.includes(name)} onChange={() => {
          const current = draft === null ? names : draft;
          setDraft(current.includes(name) ? current.filter(item => item !== name) : [...current, name]);
        }} /><span>{name}</span></label>)}
        {!matches.length && <p className="opr-muted">Sin clientes coincidentes.</p>}
      </div>
      <div className="opr-client-apply"><button type="button" onClick={() => setOpen(false)}>Cancelar</button><button type="button" className="opr-client-confirm" onClick={apply}>Aplicar</button></div>
    </div>}
  </div>;
}